/**
 * Brand settings for the Comabooks cabinet.
 * TODO(owner): fill in the real Instagram / support links before launch.
 * Empty strings hide the corresponding link/card.
 */
export const BRAND = {
  name: 'Comabooks',
  /** Lower-case wordmark shown in the top bar. */
  wordmark: 'comabooks',
  site: 'https://comabooks.io',
  /** Contact e-mail shown in footers (same mailbox as on the old site). */
  email: 'hello@comabooks.org',
  instagramHandle: 'comabooks',
  instagramUrl: 'https://www.instagram.com/comabooks/', // placeholder
  /** Where "Поддержка — Напишите нам" leads (Telegram / WhatsApp / mailto). */
  supportUrl: 'https://t.me/comabooks', // placeholder
  /** Shown on the login page under the form ("Нет аккаунта?"). */
  managerUrl: 'https://t.me/comabooks', // placeholder
} as const;

export const openExternal = (url: string) => {
  if (!url) return;
  window.open(url, '_blank', 'noopener,noreferrer');
};
